export default __webpack_public_path__ + "static/B0201-89f99d807a7d95d31fdab71f4b6b5a2f.png";